import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DefaultHeader from './DefaultHeader';
import MobileHeader from './MobileHeader';

function Header({displayMode, className, history, newUserTourIsActive})  {
			 
		if (displayMode === 'mobile') {
			return (
				<MobileHeader
					className={className}
					history={history}
				/>
			);
		} else
			return (
				<DefaultHeader
					className={className}
					history={history}
					newUserTourIsActive={newUserTourIsActive}
				/>
			);

}

function mapStateToProps(state) {
  return {
		newUserTourIsActive: state.newUserTourIsActive.results
  };
}


Header.propTypes = {
	// user: PropTypes.string.isRequired,
	// userType: PropTypes.string.isRequired,
	className: PropTypes.string,
	// headerStyles: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, null)(Header));
